@for (equipment of equipmentList; track equipment) {
  <div>
    <p class="rowMargin">
      <span class="icon icon-complete"></span>
      <span>{{ equipment }}</span>
    </p>
  </div>
}
